import { Router } from 'express'
import { CreateLeadController } from './createLeadController'
import { FetchManyLeadsController } from './fetchManyLeadsController'
import { FetchManyLeadsByOriginController } from './fetchManyLeadsByOriginController'
import { ensureIsAuthenticated } from '../../middlewares/ensureIsAuthenticatedMiddleware'
import { FetchManyLeadsByParametersController } from './fetchManyLeadsByParametersController'

const createLeadController: CreateLeadController = new CreateLeadController()
const fetchManyLeadsController: FetchManyLeadsController = new FetchManyLeadsController()
const fetchManyLeadsByOriginController: FetchManyLeadsByOriginController = new FetchManyLeadsByOriginController()
const fetchManyLeadsByParametersController: FetchManyLeadsByParametersController = new FetchManyLeadsByParametersController()

export const leadsRoutes = Router()

leadsRoutes.post(
  '/leads',
  ensureIsAuthenticated,
  createLeadController.handle.bind(createLeadController),
)

leadsRoutes.get(
  '/leads/list',
  ensureIsAuthenticated,
  fetchManyLeadsController.handle.bind(fetchManyLeadsController),
)

leadsRoutes.get(
  '/leads/filter',
  ensureIsAuthenticated,
  fetchManyLeadsByParametersController.handle.bind(fetchManyLeadsByParametersController),
)


leadsRoutes.get(
  '/leads/origin/list',
  ensureIsAuthenticated,
  fetchManyLeadsByOriginController.handle.bind(fetchManyLeadsByOriginController),
)